/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGrid = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M4 8h4V4H5.5Q4 4 4 5.5zm6 12h4v-4h-4zm-6-1.5Q4 20 5.5 20H8v-4H4zM4 14h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V5.5Q20 4 18.5 4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h2.5q1.5 0 1.5-1.5V16h-4z" /></svg>;
export default SvgGrid;